export class StringFunctions {
    static capitalize(text : string) : string {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    static removeAllButLast(string,word){
        var parts = word.split(string);
        return parts.slice(0,-1).join('') + string + parts.slice(-1);
    }
}